import styled from "styled-components";

export const FirstBlockContainer = styled.div`
	position: relative;
	width: 100%;
	height: 750px;
	display: flex;
`;
